import { Language } from 'app/main/shared/model/translateble-string.model';

export interface IBBBServerSetting {
    url?: string;
    secret?: string;
    meetingID?: string;
    recordID?: string;
    name?: string;
    fullName?: string;
    welcome?: string;
    voiceBridge?: string;
    record?: boolean;
    autoStartRecording?: boolean;
    allowStartStopRecording?: boolean;
    allowAttendeeWatchRecording?: boolean;
    logoutURL?: string;
    duration?: number;
    publish?: boolean;
    clientURL?: string;
    configToken?: string;
    avatarURL?: string;
    moderatorOnlyMessage?: string;
    animations?: boolean;
    isAlertAudioForChat?: boolean;
    isAlertPopupForChat?: boolean;
    isAlertAudioForUserJoin?: boolean;
    isAlertPopupForUserJoin?: boolean;
    language?: Language;
    isEnableWebcams?: boolean;
    isEnableDesktopSharing?: boolean;
    isBreakout?: boolean;
    freeJoin?: boolean;
    webcamsOnlyForModerator?: boolean;
    logo?: string;
    bannerText?: string;
    bannerColor?: string;
    copyright?: string;
    muteOnStart?: boolean;
    allowModsToUnmuteUsers?: boolean;
    showModsInAttendees?: boolean;
    lockSettingsDisableCam?: boolean;
    lockSettingsDisableMic?: boolean;
    lockSettingsDisablePrivateChat?: boolean;
    lockSettingsDisablePublicChat?: boolean;
    lockSettingsDisableNote?: boolean;
    lockSettingsLockedLayout?: boolean;
    lockSettingsLockOnJoin?: boolean;
    lockSettingsLockOnJoinConfigurable?: boolean;
    maxFileUploadSize?: number;
    lateTime?: number;
    endWhenNoModerator?: boolean;
    endWhenNoModeratorDelayInMinutes?: number;
    minDurationForPresent?: number;
    defaultPresentCode?: string;
    defaultAbsentCode?: string;
}

export class BBBServerSetting implements IBBBServerSetting {
    constructor(
        public url?: string,
        public secret?: string,
        public meetingID?: string,
        public recordID?: string,
        public name?: string,
        public fullName?: string,
        public welcome?: string,
        public voiceBridge?: string,
        public record?: boolean,
        public notifyRecordReadyViaSMS?: boolean,
        public notifyRecordReadyViaEmail?: boolean,
        public notifyRecordReadyViaEmailAttendees?: boolean,
        public autoStartRecording?: boolean,
        public allowStartStopRecording?: boolean,
        public allowAttendeeWatchRecording?: boolean,
        public logoutURL?: string,
        public duration?: number,
        public maxRecordingDuration?: number,
        public publish?: boolean,
        public clientURL?: string,
        public configToken?: string,
        public avatarURL?: string,
        public moderatorOnlyMessage?: string,
        public animations?: boolean,
        public isAlertAudioForChat?: boolean,
        public isAlertPopupForChat?: boolean,
        public isAlertAudioForUserJoin?: boolean,
        public isAlertPopupForUserJoin?: boolean,
        public language?: Language,
        public isEnableWebcams?: boolean,
        public isEnableDesktopSharing?: boolean,
        public isBreakout?: boolean,
        public freeJoin?: boolean,
        public webcamsOnlyForModerator?: boolean,
        public logo?: string,
        public bannerText?: string,
        public bannerColor?: string,
        public copyright?: string,
        public muteOnStart?: boolean,
        public allowModsToUnmuteUsers?: boolean,
        public showModsInAttendees?: boolean,
        public lockSettingsDisableCam?: boolean,
        public lockSettingsDisableMic?: boolean,
        public lockSettingsDisablePrivateChat?: boolean,
        public lockSettingsDisablePublicChat?: boolean,
        public lockSettingsDisableNote?: boolean,
        public lockSettingsLockedLayout?: boolean,
        public lockSettingsLockOnJoin?: boolean,
        public lockSettingsLockOnJoinConfigurable?: boolean,
        public maxFileUploadSize?: number,
        public lateTime?: number,
        public endWhenNoModerator?: boolean,
        public endWhenNoModeratorDelayInMinutes?: number,
        public recordFullDurationMedia?: boolean,
        public minDurationForPresent?: number,
        public defaultPresentCode?: string,
        public defaultAbsentCode?: string
    ) {
        this.defaultPresentCode = defaultPresentCode ?? null;
        this.defaultAbsentCode = defaultAbsentCode ?? null;
        this.url = url ? url : '';
        this.secret = secret ? secret : '';
        this.meetingID = meetingID ? meetingID : '';
        this.recordID = recordID ? recordID : '';
        this.name = name ? name : '';
        this.voiceBridge = voiceBridge ? voiceBridge : '';
        this.record = record ? record : true;
        this.notifyRecordReadyViaSMS = notifyRecordReadyViaSMS ? notifyRecordReadyViaSMS : false;
        this.notifyRecordReadyViaEmail = notifyRecordReadyViaEmail ? notifyRecordReadyViaEmail : true;
        this.notifyRecordReadyViaEmailAttendees = notifyRecordReadyViaEmailAttendees
            ? notifyRecordReadyViaEmailAttendees
            : false;
        this.autoStartRecording = autoStartRecording ? autoStartRecording : true;
        this.allowStartStopRecording = allowStartStopRecording ? allowStartStopRecording : true;
        this.allowAttendeeWatchRecording = allowAttendeeWatchRecording ? allowAttendeeWatchRecording : true;
        this.logoutURL = logoutURL ? logoutURL : '';
        this.duration = duration ? duration : 0;
        this.maxRecordingDuration = maxRecordingDuration ? maxRecordingDuration : 0;
        this.publish = publish ? publish : true;
        this.clientURL = clientURL ? clientURL : '';
        this.configToken = configToken ? configToken : '';
        this.avatarURL = avatarURL ? avatarURL : '';
        this.moderatorOnlyMessage = moderatorOnlyMessage ? moderatorOnlyMessage : '';
        this.animations = animations ? animations : true;
        this.isAlertAudioForChat = isAlertAudioForChat ? isAlertAudioForChat : true;
        this.isAlertPopupForChat = isAlertPopupForChat ? isAlertPopupForChat : true;
        this.isAlertAudioForUserJoin = isAlertAudioForUserJoin ? isAlertAudioForUserJoin : true;
        this.isAlertPopupForUserJoin = isAlertPopupForUserJoin ? isAlertPopupForUserJoin : true;
        this.language = language ? language : Language.en;
        this.isEnableWebcams = isEnableWebcams ? isEnableWebcams : true;
        this.isEnableDesktopSharing = isEnableDesktopSharing ? isEnableDesktopSharing : true;
        this.maxFileUploadSize = maxFileUploadSize ? maxFileUploadSize : 0;
        this.lateTime = lateTime ? lateTime : 0;
        this.endWhenNoModerator = endWhenNoModerator ? endWhenNoModerator : false;
        this.endWhenNoModeratorDelayInMinutes = endWhenNoModeratorDelayInMinutes
            ? endWhenNoModeratorDelayInMinutes
            : null;
        this.recordFullDurationMedia = recordFullDurationMedia ? recordFullDurationMedia : false;
        this.minDurationForPresent = minDurationForPresent ?? 0;
    }
}
